import { Controller } from "@hotwired/stimulus"

// Manages a <details>-based dropdown that escapes overflow:hidden containers.
// - Closes on outside click
// - Repositions the dropdown panel with position:fixed so it's never clipped
//
// Usage:
//   <details data-controller="dae20--click-outside">
//     <summary>⚙</summary>
//     <div data-dae20--click-outside-target="panel" class="...">
//       ...menu items...
//     </div>
//   </details>
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    // Кэшируем panel — после телепорта в body Stimulus target getter
    // может не найти её внутри this.element.
    this._panel = this.hasPanelTarget ? this.panelTarget : null

    this._onClickOutside = (event) => {
      const clickedInsidePanel = this._panel && this._panel.contains(event.target)
      if (this.element.open && !this.element.contains(event.target) && !clickedInsidePanel) {
        this.element.open = false
      }
    }
    this._onToggle = () => {
      if (this.element.open) {
        this._positionPanel()
      } else {
        this._resetPanel()
      }
    }
    document.addEventListener("click", this._onClickOutside, true)
    this.element.addEventListener("toggle", this._onToggle)
  }

  disconnect() {
    document.removeEventListener("click", this._onClickOutside, true)
    this.element.removeEventListener("toggle", this._onToggle)
    this._resetPanel()
  }

  _positionPanel() {
    if (!this._panel) return
    const summary = this.element.querySelector("summary")
    if (!summary) return

    const rect = summary.getBoundingClientRect()

    // Телепортируем panel в body, чтобы она не была обрезана
    // stacking context grid-компонента (isolate + z-index).
    document.body.appendChild(this._panel)

    this._panel.style.position = "fixed"
    this._panel.style.top = `${rect.bottom + 4}px`
    this._panel.style.right = "auto"
    this._panel.style.left = `${Math.min(rect.left, window.innerWidth - 180)}px`
    this._panel.style.zIndex = "9999"
  }

  _resetPanel() {
    if (!this._panel) return
    // Возвращаем panel обратно в <details>
    this.element.appendChild(this._panel)
    this._panel.style.position = ""
    this._panel.style.top = ""
    this._panel.style.right = ""
    this._panel.style.left = ""
    this._panel.style.zIndex = ""
  }
}
